import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class GroupMemberSearchParams extends SearchParamsBase {
  initialize() {
    this.UserName = '';
    this.UserUserName = '';
    this.Email = '';
    this.GroupId = 0;
  }

  static fieldsInSearchBox = [
    { fieldName: 'UserName', label: 'User Name', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'UserUserName', label: 'Usename', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'Email', label: 'Email', className: 'col-4', type: InputTypesEnum.Text },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'GroupMemberSearchParams';

  static ConvertToJSON(originalSearchItem) {
    const correctedSearchItem = { ...originalSearchItem };

    for (const prop in correctedSearchItem) {
      correctedSearchItem[prop] = correctedSearchItem[prop].toString();
    }
    return JSON.stringify(correctedSearchItem);
  }
}
